import React from "react";
import { Card } from "antd";
import { SbCardWrapper } from "./SbCard.styles";

const SbCard = ({ className = "", children, ...props }) => {
  return (
    <SbCardWrapper className={className} {...props}>
      {children}
    </SbCardWrapper>
  );
};

export default SbCard;